module.exports = __webpack_public_path__ + "static/img/testimony (15).fce1bf89.jpg";